function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/prop-types */
import React from 'react';
const RulesMiddleware = _ref => {
  let {
    children,
    middlewareProps,
    renderRules = [],
    propRules = {}
  } = _ref;
  const {
    operator = 'AND'
  } = middlewareProps;
  const undefinedCheck = element => element !== undefined;
  const hasAllRules = renderRules.every(undefinedCheck);
  let shouldRender = true;
  if (renderRules.length && hasAllRules) {
    if (operator === 'AND') {
      shouldRender = renderRules.every(Boolean);
    } else if (operator === 'OR') {
      shouldRender = renderRules.some(Boolean);
    }
  }
  if (!shouldRender) {
    return null;
  }
  return children({
    props: _objectSpread({}, propRules)
  });
};
RulesMiddleware.propTypes = {};
RulesMiddleware.displayName = 'RulesMiddleware';
RulesMiddleware.dataModel = {};
export { RulesMiddleware };
//# sourceMappingURL=RulesMiddleware.js.map